<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Logout',
  methods: {
    ...mapActions(['logoutAction', 'setMessage'])
  },
  computed: {
    ...mapGetters({
      message: 'getMessage'
    })
  },
  beforeMount() {
    this.logoutAction();
    this.setMessage({ status: 'info', text: this.$i18n.t('login.succesfullyLogedOut') });
  }
};
</script>
